import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
`;

const About = () => {
  return (
    <PageContainer>
      <h1>About</h1>
    </PageContainer>
  );
};

export default About;